<!-- #region Tableau -->
<dx-data-grid
    #datagrid
    [dataSource]="bonsAchatDataSource"
    [showBorders]="true"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    [height]="'100%'"
    (onExporting)="onExporting($event, 'bon achat')"
    class="grid theme-dependent"
    (onRowInserting)="onRowInserting($event.data)"
    (onInitNewRow)="onInitNewRow($event)"
>
    <!-- #region Toolbar -->
    <dxo-toolbar>
        <!-- Elements non nécessaires pour la vue détail activité-->
        <ng-container *ngIf="activiteId == null">
            <dxi-item location="before">
                <div class="grid-header">{{ title }}</div>
            </dxi-item>
            <dxi-item location="center">
                <div *dxTemplate>
                    <dx-form labelLocation="left" [formData]="this" [colCount]="4">
                        <!-- Date début -->
                        <dxi-item dataField="dateDebut"
                            [label]="{ text: 'Début' }"
                            editorType="dxDateBox"
                            [editorOptions]="{
                            showClearButton: true
                            }"
                        ></dxi-item>

                        <!-- Date fin -->
                        <dxi-item dataField="dateFin"
                            [label]="{ text: 'Fin' }"
                            editorType="dxDateBox"
                            [editorOptions]="{
                            showClearButton: true
                            }"
                        ></dxi-item>

                        <!-- Rechercher -->
                        <dxi-item
                            editorType="dxButton"
                            [editorOptions]="{
                            text: 'Rechercher',
                            onClick: setBonsAchat,
                            stylingMode: 'contained',
                            type: 'default',
                            icon: 'search'
                            }"
                        ></dxi-item>

                        <!-- En cours de validité -->
                        <dxi-item dataField="onlyValid"
                            editorType="dxCheckBox"
                            [label]="{ visible: false}"
                            [editorOptions]="{
                                text: 'En cours de validité',
                                onValueChanged: setBonsAchat,
                                elementAttr: { style: 'padding-top: 10px' }
                            }"
                    ></dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item>
                <div *dxTemplate>
                    <dx-button icon="refresh" hint="Rafraîchir" (onClick)="setBonsAchat()" stylingMode="text"></dx-button>
                </div>
            </dxi-item>
            <dxi-item name="exportButton"></dxi-item>
            <dxi-item>
                <div *dxTemplate>
                    <dx-button text="Importer" (onClick)="this.showImportCsvPopup = true" type="default" icon="import"></dx-button>
                </div>
            </dxi-item>
            <dxi-item>
                <div *dxTemplate>
                    <dx-button text="Template" style="margin-right: 12px;" (onClick)="downloadTemplate()" [disabled]="recuperationTemplateEncours" type="default">
                        <div style="display: flex; align-items: center;">
                            <dx-load-indicator [visible]="recuperationTemplateEncours" height="20" width="20"></dx-load-indicator>
                            <span class="dx-button-text" [ngStyle]="{'margin-left': recuperationTemplateEncours ? '10px' : 'auto'}">
                            Modèle CSV
                            </span>
                        </div>
                    </dx-button>
                </div>
            </dxi-item>
        </ng-container>
        <dxi-item name="addRowButton"></dxi-item>
        <dxi-item name="columnChooserButton"></dxi-item>
    </dxo-toolbar>
    <!-- #endregion -->

    <!-- #region Options -->
    <dxo-editing mode="row" [allowAdding]="canAdministrerBonAchat" [allowUpdating]="canAdministrerBonAchat" [allowDeleting]="canAdministrerBonAchat"></dxo-editing>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-remote-operations [sorting]="true" [filtering]="true" [paging]="true" [grouping]="true" [groupPaging]="true"></dxo-remote-operations>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true">
        <dxo-search [enabled]="true"></dxo-search>
      </dxo-header-filter>
    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
    <dxo-selection mode="multiple" *ngIf="activiteId == null"></dxo-selection>
    <dxo-paging [enabled]="true" [pageSize]="25"></dxo-paging>
    <dxo-pager [allowedPageSizes]="[25, 50, 100]" [showInfo]="true" [visible]="true"></dxo-pager>
    <dxo-column-chooser [enabled]="true" mode="select" [height]="600"></dxo-column-chooser>
    <!-- #endregion -->

    <!-- #region Colonnes -->
    <dxi-column dataField="id" caption="Id" [allowEditing]="false" [width]="70" [visible]="false"></dxi-column>
    <dxi-column dataField="numero" caption="Numéro" [width]="110">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="montant" format="fixedPoint" caption="Montant" [width]="120" [calculateCellValue]="valeurAbsolue"></dxi-column>
    <dxi-column dataField="deviseId" caption="Devise" [width]="80" >
        <dxo-lookup [dataSource]="deviseDataSource" valueExpr="id" displayExpr="codeISO"></dxo-lookup>
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="statut" caption="Statut" [width]="100">
        <dxo-lookup [dataSource]="statutDataSource" valueExpr="id" displayExpr="libelle"></dxo-lookup>
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="type" caption="Type" [width]="100" [visible]="false">
        <dxo-lookup [dataSource]="typeDataSource" valueExpr="id" displayExpr="libelle"></dxo-lookup>
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="dateValidite" caption="Date de validité" dataType="date" format="dd/MM/yyyy" width="150"></dxi-column>

    <dxi-column dataField="noPiece" caption="Pièce" [width]="120" [allowEditing]="false" cellTemplate="noPieceCellTemplate">
        <div *dxTemplate="let data of 'noPieceCellTemplate'">
            <a [routerLink]="'/vente/pieces/' + data?.data?.pieceId" title="Voir la pièce">
                {{data?.value}}
            </a>
        </div>
    </dxi-column>

    <dxi-column dataField="nomClientPiece" caption="Client" [allowEditing]="false"></dxi-column>
    <dxi-column *ngIf="this.activiteId == null" dataField="activiteIntitule" caption="Activité" dataType="string" cellTemplate="intituleCellTemplate">
        <div *dxTemplate="let data of 'intituleCellTemplate'">
            <a routerLink="/sav/activites/{{data.data.activiteId}}" title="Voir l'activité">
                {{data.value}}
            </a>
        </div>
    </dxi-column>

    <dxi-column dataField="articleLibelle" caption="Article" [width]="200" [allowEditing]="false" [visible]="articleId == null" cellTemplate="articleCellTemplate">
        <div *dxTemplate="let data of 'articleCellTemplate'">
            <a [routerLink]="'/article/' + data?.data?.articleId" title="Voir l'article">
                {{data?.value}}
            </a>
        </div>
    </dxi-column>
    <!-- #endregion -->
</dx-data-grid>
<!-- #endregion -->

<!-- #region Popups -->
<!-- Popup : Info import CSV -->
<dx-popup
  [width]="500"
  [height]="450"
  title = "Importer des bons d'achat via fichier .csv"
  [(visible)]="showImportCsvPopup"
  [showCloseButton]="true"
>
  <div *dxTemplate="let data of 'content'">
    <div [hidden]="showLoader">
      <dx-file-uploader
        [multiple]="false"
        [allowedFileExtensions]="['.csv']"
        uploadMode="useForm"
        selectButtonText="Importer un fichier .csv"
        readyToUploadMessage=""
        labelText="ou Glisser/Déposer le fichier"
        [(value)]="fichierCsv"
        (click)="resetImportResultMsg()"
      ></dx-file-uploader>
      <dx-button style="margin-right: 10px;" (click)="cancelImportCsv()" text="Annuler"></dx-button>
      <dx-button (click)="importDataFromCsv()" text="Importer" [disabled]="!fichierCsv[0]?.name.endsWith('.csv')" type="default"></dx-button>
      <div *ngIf="importCsvResultMsg" style="margin-top: 20px;">
        <p>
          <b *ngIf="!importHasFailed">Résultat</b>
          <b *ngIf="importHasFailed" style="color: red;">Une erreur est survenue lors de l'importation CSV</b>
        </p>
        <p>{{importCsvResultMsg}}</p>
        <p>{{importCsvResultMsg2}}</p>
      </div>
    </div>
    <div [hidden]="!showLoader" style="display: flex; justify-content: center; align-items: center;">
      <dx-load-indicator [visible]="showLoader" height="150" width="150"></dx-load-indicator>
    </div>
  </div>
</dx-popup>
<!-- #endregion -->